export const AR = {
    title: 'البعض من مشاريعنا',
    des: ' تصاميم داخلية مميزة، مصممة خصيصا لتلبية احتياجاتكم وتفضيلاتكم الخاصة.',
    btn: 'المزيد'
}

export const USA = {
    title: 'Some of out projects',
    des: 'Distinctive interior designs, tailored to meet your specific needs and preferences.',
    btn: 'More'
}